import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'faire_direct-faire_direct_foi_top_nav_banner_cta-action_category_click';

/**
 * Tracks when retailer clicks on the top nav banner CTA for FD FOI
 */
export function trackFaireDirectFaireDirectFoiTopNavBannerCtaActionCategoryClick(
  linkAction: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { linkAction },
  });
}
